import { CSSObject } from '@emotion/react'
import { Fragment } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames, renderIcon } from '@opallabs/kuiper'
import { AccountName } from '@opallabs/periodic/src/AccountName'
import { ContentAvatar } from '@opallabs/periodic/src/ContentAvatar'
import { sharedColors, sharedStyles } from '../../sharedStyles'
import { styles } from './styles'

export type HeaderProps = {
  accountImage: AssetReference | null
  accountName: string
  instagramCollab?: boolean
  collabAccount?: string
  modulesLength: number
  currentIndex: number
  postType: string
}

type AccountNameProps = {
  name: string
  color: string
  style: CSSObject
}

const getSecondAccountProps = (collabAccount?: string): AccountNameProps => ({
  name: collabAccount || 'No collab account',
  color: collabAccount ? 'white' : (sharedColors.emptyCollab as string),
  style: styles.accountCollabNameStyles,
})

const getIndicatorElems = (
  modulesLength: number,
  currentIndex: number
): JSX.Element[] => {
  const indicatorArray = Array.from(Array(modulesLength)).map((blank, i) => (
    <li
      key={`indicator-${i}`}
      className={kuiperClassNames(
        'story-indicator',
        i <= currentIndex ? 'active' : ''
      )}
      css={styles.getIndicatorStyles(i <= currentIndex)}
    />
  ))
  return indicatorArray
}

export const InstagramStoryHeader: React.FC<HeaderProps> = ({
  accountImage,
  accountName,
  collabAccount,
  instagramCollab,
  modulesLength,
  currentIndex,
  postType,
}) => {
  return (
    <div css={styles.baseStyles}>
      <ul css={styles.indicatorContainerStyles}>
        {getIndicatorElems(modulesLength, currentIndex)}
      </ul>
      <div css={styles.infoContainerStyles}>
        <div css={styles.accountContainerStyles}>
          <div>
            {instagramCollab ? (
              <Fragment>
                <div css={sharedStyles.collabAvatarStyles as CSSObject}>
                  <ContentAvatar assetReference={accountImage} size={24} />
                  <ContentAvatar
                    assetReference={null}
                    size={24}
                    style={sharedStyles.secondAvatarStyles as CSSObject}
                  />
                </div>
                <div css={styles.accountNameWrapperStyles}>
                  <div css={styles.collabAccountStyles}>
                    <AccountName
                      name={accountName}
                      color={'white'}
                      style={styles.accountNameStyles}
                    />
                    <span> and </span>
                    <AccountName {...getSecondAccountProps(collabAccount)} />
                  </div>
                </div>
              </Fragment>
            ) : (
              <Fragment>
                <ContentAvatar assetReference={accountImage} />
                <div css={styles.standardAccountStyles}>
                  <AccountName
                    name={accountName}
                    color={'white'}
                    style={styles.accountNameStyles}
                  />
                </div>
              </Fragment>
            )}
            {postType !== 'instagram_story' && (
              <div css={styles.sponsoredText}>
                Sponsored
                {postType.includes('expandable') && currentIndex === 0 && (
                  <Fragment>
                    <span css={styles.sponsoredMiddot}>&middot;</span>
                    <span css={styles.sponsoredPlayIcon}>
                      {renderIcon('instagram-mobile-play', {
                        ariaMode: 'hidden',
                        height: 6,
                        width: 7,
                      })}
                    </span>
                    <span>Keep watching</span>
                  </Fragment>
                )}
              </div>
            )}
          </div>
        </div>
        <div css={styles.iconContainerStyles}>
          <div css={styles.moreIconStyles}>
            {renderIcon('instagram-mobile-more', { ariaMode: 'hidden' })}
          </div>
          <div css={styles.closeIconStyles}>
            {renderIcon('instagram-mobile-close', { ariaMode: 'hidden' })}
          </div>
        </div>
      </div>
    </div>
  )
}
